import React from 'react';

export interface ScheduleCancelConfirmCopy {
  title: string;
  summary: string;
  chargesStop: string;
  resume: string;
  cancelLabel: string;
  confirmLabel: string;
  pendingConfirmLabel: string;
}

export function buildScheduleCancelConfirmCopy(options: {
  planName: string;
  periodEndLabel: string;
}): ScheduleCancelConfirmCopy {
  const normalizedPlanName = options.planName.trim() || 'Текущий платный тариф';
  const normalizedPeriodEndLabel = options.periodEndLabel.trim() || 'конца текущего периода';

  return {
    title: 'Отменить подписку в конце периода?',
    summary: `Тариф «${normalizedPlanName}» останется активным до ${normalizedPeriodEndLabel}.`,
    chargesStop: 'После этой даты будущие автоматические списания прекратятся.',
    resume: `До ${normalizedPeriodEndLabel} вы сможете возобновить подписку в этом разделе, если передумаете.`,
    cancelLabel: 'Не отменять',
    confirmLabel: 'Подтвердить отмену',
    pendingConfirmLabel: 'Планируем…',
  };
}

interface ScheduleCancelConfirmDialogBodyProps {
  planName: string;
  periodEndLabel: string;
}

export function ScheduleCancelConfirmDialogBody({
  planName,
  periodEndLabel,
}: ScheduleCancelConfirmDialogBodyProps) {
  const copy = buildScheduleCancelConfirmCopy({ planName, periodEndLabel });

  return (
    <div className="space-y-3 text-sm leading-relaxed text-[var(--site-ink-muted)]">
      <p>{copy.summary}</p>
      <p>{copy.chargesStop}</p>
      <p>{copy.resume}</p>
    </div>
  );
}
